/*
 * Injects a strikethrough "reference price" into the Loop Subscriptions
 * widget's "One-time purchase" row whenever the customer has selected a
 * multi-pack variant that is discounted vs. the single pack.
 *
 * Reference price source of truth is:
 *   1. variant.compare_at_price, if the merchant has set one
 *   2. otherwise: single-variant price * pack size (per-unit fallback)
 */
(function () {
  var BADGE_CLASS = 'hg-onetime-compare-at';
  var productCache = null;

  function parsePackSize(text) {
    var m = String(text || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 1;
  }

  function fetchProduct() {
    if (productCache) return Promise.resolve(productCache);
    var handle = location.pathname.split('/').filter(Boolean).pop();
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache = p; return p; })
      .catch(function () { return null; });
  }

  function currentVariantId() {
    var params = new URLSearchParams(location.search);
    var v = params.get('variant');
    if (v) return parseInt(v, 10);

    var sel = document.querySelector('variant-selects [data-selected-variant]');
    if (sel) {
      try { return JSON.parse(sel.textContent).id; } catch (_) {}
    }
    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (_) {}
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function computeReferencePrice(variant, product) {
    if (!variant) return 0;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return variant.compare_at_price;
    }

    var packSize = parsePackSize(variant.option1 || variant.title);
    if (packSize <= 1) return 0;

    var single = product.variants.find(function (v) {
      return parsePackSize(v.option1 || v.title) === 1;
    }) || product.variants[0];
    if (!single) return 0;

    var fullPrice = single.price * packSize;
    if (fullPrice <= variant.price) return 0;
    return fullPrice;
  }

  function findOneTimeRow() {
    var widgets = document.querySelectorAll('.loop-widget-container, [class*="loop-widget-container-id"]');
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      var rows = widget.querySelectorAll('[class*="purchase-option"]');
      for (var j = 0; j < rows.length; j++) {
        var row = rows[j];
        if (!/purchase-option(s|-header)/i.test(row.className || '')) {
          var text = (row.textContent || '').toLowerCase();
          if (/one[\s-]?time/.test(text) && !/subscribe|subscription/.test(text)) {
            return row;
          }
        }
      }
    }
    return null;
  }

  function findPriceContainer(row) {
    return (
      row.querySelector('[class*="price-container"]') ||
      row.querySelector('[class*="price"]') ||
      row
    );
  }

  function render() {
    var row = findOneTimeRow();
    if (!row) return;

    fetchProduct().then(function (product) {
      if (!product) return;

      var variantId = currentVariantId();
      var variant = product.variants.find(function (v) { return v.id === variantId; })
        || product.variants.find(function (v) { return v.available; })
        || product.variants[0];

      var referencePrice = computeReferencePrice(variant, product);
      var existing = row.querySelector('.' + BADGE_CLASS);

      if (!referencePrice) {
        if (existing) existing.remove();
        return;
      }

      var label = formatMoney(referencePrice);
      if (existing) {
        if (existing.textContent !== label) existing.textContent = label;
        return;
      }

      var compareEl = document.createElement('s');
      compareEl.className = BADGE_CLASS;
      compareEl.textContent = label;

      var container = findPriceContainer(row);
      container.insertBefore(compareEl, container.firstChild);
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      render();
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      setTimeout(schedule, 150);
    }
  });

  var observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
